
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 3.41L17.21 8.7 20.5 12h-8V4l3.29 3.29L21.09 2l1.41 1.41zM3.91 22l5.29-5.29L12.5 20v-8h-8l3.29 3.29-5.29 5.3L3.91 22z","fill":"#1D1B1E"}})])
          )
        }
      }
    